import {FC} from 'react'
import SharedBenefits from "./benefits"
import RegisterHero from "./register-hero"
import Prices from "./prices"

type Props = {
  renderForm: () => any
  isLoading: boolean
}

const Shared: FC<Props> = ({renderForm, isLoading}) => {

  return (
    <>
      <RegisterHero renderForm={renderForm}/>
      <SharedBenefits/>
      <Prices/>
    </>
  )
}

export default Shared

